import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import messages from './../../../text/messages';
import { FormattedMessage } from 'react-intl';
import Tabs from './../../../components/tabs';
import ContractorAllDocs from '../tabs/contractorAllDocs';
import ContractorPolicyDocs from '../tabs/contractorPolicyDocs';
import ContractorI9 from '../tabs/contractorI9';
import { getJobs } from './../../../reducers/jobs';
import IcContinueRequestDocs from './../../../components/lists/workerDocumentsICContinue';
import { isW2 } from '../../../utilities/jobStatus';

class ContractorDocuments extends React.Component {
    componentDidMount() {
        const { getJobs, role, job } = this.props;
        if (!job) {
            getJobs(role);
        }
    }

    render() {
        const { progress } = this.props.job;
        const { branch } = progress || {};

        const tabs = isW2(this.props.job)
            ? [
                  { title: <FormattedMessage {...messages.personalDocuments} />, content: <ContractorAllDocs /> },
                  { title: <FormattedMessage {...messages.contractorGlobalDocs} />, content: <ContractorPolicyDocs /> },
                  { title: <FormattedMessage {...messages.i9} />, content: <ContractorI9 /> }
              ]
            : [
                  {
                      title: <FormattedMessage {...messages.documents} />,
                      content: branch === 'ic-continue-request' ? <IcContinueRequestDocs /> : <ContractorAllDocs />
                  }
              ];

        const { label } = this.props.page;

        return (
            <div className="page>">
                <div className="row section">
                    <div className="col-xs-12">
                        <Tabs items={tabs} pageWide title={label} isPageTitle={true} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    role: state.identity.role,
    job: state.jobs.list && state.jobs.list.length ? state.jobs.list[0] : {}
});

const mapDispatchToProps = dispatch => bindActionCreators({ getJobs }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ContractorDocuments);



// WEBPACK FOOTER //
// ./src/pages/documents/tenants/contractor.jsx